export default __webpack_public_path__ + "static/media/cover.c4db12b0.png";